"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactstrap = require("reactstrap");
var _helpers = require("../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Duration = ({
  name,
  value,
  onChange
}) => {
  const duration = _moment.default.duration(value);
  const days = Math.floor(duration.asDays());
  const handleChange = (event, type) => {
    let newDuration;
    switch (type) {
      case "days":
        const newDays = event.target.value;
        newDuration = _moment.default.duration({
          minutes: duration.minutes(),
          hours: duration.hours(),
          days: newDays
        });
        break;
      case "time":
        const hoursMinutes = (0, _moment.default)(event.target.value, "HH:mm");
        newDuration = _moment.default.duration({
          hours: hoursMinutes.format("HH"),
          minutes: hoursMinutes.format("mm"),
          days
        });
        break;
    }
    onChange((0, _helpers.formatDurationToASP)(newDuration));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "form-inline"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group mr-2"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "number",
    name: "number",
    id: "exampleNumber",
    placeholder: "number placeholder",
    value: days,
    onChange: event => handleChange(event, "days")
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Input, {
    type: "time",
    name: "time",
    id: "exampleNumber",
    placeholder: "number placeholder",
    value: (0, _moment.default)(duration._data).format("HH:mm"),
    onChange: event => handleChange(event, "time")
  })));
};
var _default = exports.default = Duration;
module.exports = exports.default;